<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <letting-translation-control [control]="form.controls['phrase']" type="box" requiredCulture="sv-SE"></letting-translation-control>
          <astral-toggle [control]="form.controls['isActive']"></astral-toggle>
        </astral-layout-group>
      </section>
    </form>
  }
</section>
